// src/pages/B2B/event-reports/pdf/warm/sections/WarmSpotlightBox.tsx
import React from 'react';
import { SpotlightMiniChart } from '../charts/SpotlightMiniChart';
import type { BroadcastRow, SpotlightVenue } from '../../../types';

interface Props {
  venue: SpotlightVenue;
  timezone: string;
  windowStartUtcIso: string;
  windowMinutes: number;
}

function fmt(n: number): string { return n.toLocaleString(); }

function formatLocalTime(iso: string, timeZone: string): string {
  const d = new Date(iso);
  return d.toLocaleTimeString(undefined, { timeZone, hour: 'numeric', minute: '2-digit' });
}

export function WarmSpotlightBox(props: Props): React.ReactElement {
  const { venue, timezone, windowStartUtcIso, windowMinutes } = props;
  const tn = venue.trigger_notification;

  // The spotlight venue's trigger_notification is shape-compatible with
  // BroadcastRow except it lacks `opened_count`. Cast for the chart prop;
  // EngagementChart only reads `sent_at_utc` and `title`.
  const triggerForChart = tn
    ? ({ ...tn, opened_count: 0 } as BroadcastRow)
    : null;

  return (
    <div className="box">
      <h2>Top venue spotlight · {venue.name}</h2>
      <div className="box-grid">
        <div className="stat"><div className="lbl">Deal views</div><div className="val">{fmt(venue.deal_views)}</div></div>
        <div className="stat"><div className="lbl">Event interests</div><div className="val">{fmt(venue.going_clicks)}</div></div>
      </div>

      <div className="trigger-row">
        <div className="trigger-label">Triggering push:</div>
        {tn ? (
          <div className="trigger">
            <div className="trigger-time">{formatLocalTime(tn.sent_at_utc, timezone)}</div>
            <div className="trigger-meta">{fmt(tn.audience_count)} audience · {fmt(tn.delivered_count)} received</div>
          </div>
        ) : (
          <div className="trigger muted">No targeted notification recorded.</div>
        )}
      </div>

      <div style={{ marginTop: 22 }}>
        <SpotlightMiniChart
          samples={venue.active_users_samples}
          triggerNotification={triggerForChart}
          timezone={timezone}
          windowStartUtcIso={windowStartUtcIso}
          windowMinutes={windowMinutes}
        />
      </div>
    </div>
  );
}
